<script lang="ts">
    import { Col } from "sveltestrap";
    import { Lead, LeadContent, LeadMessage } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12">
    <Card cardHeader2props="pb-0"> 
      <div slot="customHeader2">
        <h5>{Lead}</h5>
        <span>{@html LeadMessage}</span>
      </div>
      <div slot="contentbody">
        <p class="lead">{LeadContent}</p>
      </div>
    </Card>
</Col>